import { cn } from "@/lib/utils";

type AuthIconBadgeVariant = "default" | "success";

interface AuthIconBadgeProps {
  children: React.ReactNode;
  variant?: AuthIconBadgeVariant;
}

export function AuthIconBadge({
  children,
  variant = "default",
}: AuthIconBadgeProps) {
  return (
    <div
      className={cn(
        "flex h-14 w-14 items-center justify-center rounded-2xl border transition-colors",
        variant === "success"
          ? "border-[var(--colors-border-border-success)] bg-[var(--colors-background-bg-success-50)]"
          : "border-border-secondary dark:border-border-secondary bg-bg-secondary dark:bg-bg-secondary",
      )}
    >
      {children}
    </div>
  );
}
